import React from "react";

const InnerPlayIcon = ({ style, size = 24 }) =>
  <svg width={size} height={size} style={style} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.6552 11.3421L8.2552 4.14239C8.1184 4.048 7.96 4 7.8 4C7.6728 4 7.5456 4.0304 7.4288 4.0912C7.1648 4.22959 7 4.50238 7 4.79997L7 19.1994C7 19.497 7.1648 19.7698 7.4288 19.9082C7.692 20.0474 8.0104 20.0266 8.2552 19.8578L18.6552 12.6581C18.8712 12.5077 19 12.2621 19 11.9997C19 11.7373 18.8712 11.4917 18.6552 11.3421Z" fill="white" />
  </svg>;

export default InnerPlayIcon;

